import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { Cap } from '../../types/caps';
const normalizeDate = (value: unknown): string | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const m = moment(value as moment.MomentInput);
    return m.isValid() ? m.format('YYYY-MM-DD') : null;
};

const normalizeString = (value: unknown): string | null => {
    if (value === null || value === undefined) {
        return null;
    }
    const trimmed = String(value).trim();
    return trimmed.length === 0 ? null : trimmed;
};

const normalizeNumber = (value: unknown): number | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};


const normalizeNumberArray = (values: unknown[] = []): number[] =>
    (values ?? [])
        .map((v) => Number(v))
        .filter((n) => Number.isFinite(n) && n >= 0)
        .sort((a, b) => a - b);

const normalizeStringArray = (values: unknown[] = []): string[] =>
    (values ?? [])
        .map((v) => normalizeString(v))
        .filter((v): v is string => v !== null)
        .sort((a, b) => a.localeCompare(b));

export const normalizeCap = (cap: Cap) => ({
    name: normalizeString(cap.name),
    amount: normalizeNumber(cap.amount),
    activeStart: normalizeDate(cap.activeStart),
    activeEnd: normalizeDate(cap.activeEnd),
    period: normalizeString(cap.period),
    loanType: normalizeString(cap.loanType),
    states: normalizeStringArray(cap.states as unknown[]),
    origins: normalizeNumberArray(cap.origins as unknown[]),
    campaigns: normalizeNumberArray(cap.campaigns as unknown[]),
    customerTypes: normalizeNumberArray(cap.customerTypes as unknown[]),
});

export const hasCapsChanges = (originalCap: Cap, updatedCap: Cap): boolean =>
    !isEqual(normalizeCap(originalCap), normalizeCap(updatedCap));